import { Facets } from '@zonofi/zono-money-store';
import { ExpandableMenu, ExpandableMenuItem, TagChip } from '../../components';
import './product-facets.scss';
import { camelCase, startCase } from 'lodash';

interface ProductFacetsProps {
  facets: Facets[];
  isProductPricing?: boolean;
}

export const ProductFacets: React.FC<ProductFacetsProps> = ({
  facets,
  isProductPricing,
}) => {
  const isVisible = !!facets?.length;
  const firstFacet = facets[0];
  const additionalFacets = facets.slice(1);
  if (!isProductPricing || !isVisible) return null;

  const mainContent = (
    <span className="facet font-regular">
      {startCase(camelCase(firstFacet?.name))}:{' '}
      <span className="facet font-regular">
        {firstFacet?.values?.[0]?.facetValue}
      </span>
    </span>
  );

  const additionalItems: ExpandableMenuItem[] = additionalFacets.map(
    (facet) => ({
      id: facet?.code || `facet-${Math.random()}`,
      content: (
        <span className="additional-facets-item-name font-regular">
          {startCase(camelCase(facet?.name))}:{' '}
          <span className="additional-facets-item-name-value font-regular">
            {facet.values?.[0]?.facetValue}
          </span>
        </span>
      ),
    })
  );

  return (
    <ExpandableMenu
      mainContent={mainContent}
      additionalItems={additionalItems}
      triggerComponent={(count, onToggle) => (
        <div onClick={onToggle}>
          <TagChip tagName={`+${count}`} needTagIcon={false} variant="gray" />
        </div>
      )}
      className="product-facets"
      popupClassName="additional-facets"
      popupItemClassName="additional-facets-item"
    />
  );
};
